module.exports = __webpack_public_path__ + "img/down.3a5ee135.png";